import { CUBE_AGGREGATE_INTERACTION, CUBE_AGGREGATE_INTERACTION_FIELD_FORCE } from '@/api/hcp/interaction/types';
import { Channel } from '@/models/channelFocus';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { useChannelFocusStore } from '@/pages/ChannelFocus/store/useChannelFocusStore';
import { GetOptionsQueryFunction, LimitedQuery } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';
import { Filter } from '@cubejs-client/core';
import { FIELD_FORCE_FILTER_LIMIT } from '../../filterDefaultLimits';

const FIELD_FORCE_OPTIONS: GetOptionsQueryFunction = ({ sourceCube, dateRange }) => {
  const timeDimensions = getDateRangeTimeDimension({
    dateRange,
    dimension: `${CUBE_AGGREGATE_INTERACTION}.interaction_date`,
  });

  const baseFilters: Filter[] = [{ member: `${sourceCube}.hcp_bk`, operator: 'set' }];

  const query: LimitedQuery = {
    dimensions: [`${CUBE_AGGREGATE_INTERACTION_FIELD_FORCE}.field_force_code`],
    limit: FIELD_FORCE_FILTER_LIMIT,
    filters: baseFilters,
    timeDimensions: [timeDimensions],
  };

  const store = useChannelFocusStore.getState();
  const channelValue = store?.channel;

  if (channelValue === Channel.VISITS_1_TO_1) {
    query.filters.push({
      member: `${sourceCube}.is_1to1visit`,
      operator: 'equals',
      values: ['1'],
    });
  } else if (channelValue === Channel.EMAIL) {
    query.filters.push({
      member: `${sourceCube}.channel`,
      operator: 'equals',
      values: ['Email'],
    });
  } else if (channelValue === Channel.EVENT) {
    query.filters.push({
      member: `${sourceCube}.is_invitation`,
      operator: 'equals',
      values: ['1'],
    });
  } else if (channelValue === Channel.WEBSITE) {
    query.filters.push({
      member: `${sourceCube}.is_website_visit`,
      operator: 'equals',
      values: ['1'],
    });
  }

  return query;
};

const fieldForceFilter: FilterConfigDynamic = {
  searchable: true,
  label: 'main.channelFocus.hcpCoverage.filters.fieldForce.label',
  placeholder: 'main.channelFocus.hcpCoverage.filters.fieldForce.placeholder',
  type: 'multiselect',
  defaultValue: [],
  clearable: true,
  sourceCube: CUBE_AGGREGATE_INTERACTION,
  getOptionsQuery: ({ sourceCube, dateRange }) => {
    const query = FIELD_FORCE_OPTIONS({ sourceCube, dateRange });
    return query;
  },
  mapResult: mapDimensionToOption(`${CUBE_AGGREGATE_INTERACTION_FIELD_FORCE}.field_force_code`),
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${CUBE_AGGREGATE_INTERACTION_FIELD_FORCE}.field_force_code`,
      operator: 'equals',
      values: [...v],
    };
  },
};

export default fieldForceFilter;
